import React from 'react'
import TemplateMain from '../../components/admin-component/templates/TemplateMain'

const Templates = () => {
    return (
        <>
            <TemplateMain />
        </>
    )
}

export default Templates